export const LightMode = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 437 280"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1462_13889)">
        <g filter="url(#filter0_d_1462_13889)">
          <rect
            width="106"
            height="279.5"
            transform="translate(330.5)"
            fill="#F9F9FB"
          />
          <rect
            width="106"
            height="53"
            transform="translate(330.5)"
            fill="white"
          />
          <rect
            x="361.875"
            y="11.25"
            width="43.25"
            height="7.5"
            rx="2"
            fill="#F2F3F7"
          />
          <rect x="336.5" y="34" width="52" height="8" rx="2" fill="#F2F3F7" />
          <rect x="336.5" y="45" width="52" height="8" rx="2" fill="#F2F3F7" />
          <rect
            width="106"
            height="22.25"
            transform="translate(330.5 53)"
            fill="white"
          />
          <g filter="url(#filter1_i_1462_13889)">
            <rect
              x="330.5"
              y="75.25"
              width="106"
              height="204.25"
              fill="#F9F9FB"
            />
          </g>
        </g>
        <rect
          width="210"
          height="279.5"
          transform="translate(120.5)"
          fill="white"
        />
        <g filter="url(#filter2_d_1462_13889)">
          <rect
            width="210"
            height="22"
            transform="translate(120.5)"
            fill="white"
          />
          <rect
            x="132.5"
            y="7.875"
            width="37"
            height="6.25"
            rx="2"
            fill="#F2F3F7"
          />
        </g>
        <rect
          x="216.75"
          y="166"
          width="101.75"
          height="30"
          rx="8"
          fill="#424DE5"
        />
        <rect
          x="132.5"
          y="206"
          width="101.75"
          height="30"
          rx="8"
          fill="#D2D5E3"
        />
        <g filter="url(#filter3_d_1462_13889)">
          <rect
            width="210"
            height="31.5"
            transform="translate(120.5 248)"
            fill="white"
          />
          <rect
            width="105"
            height="12"
            transform="translate(120.5 248)"
            fill="white"
          />
          <rect x="120.5" y="258" width="105" height="2" fill="#5A68ED" />
          <mask id="path-10-inside-1_1462_13889" fill="white">
            <path d="M225.5 248H330.5V260H225.5V248Z" />
          </mask>
          <path d="M225.5 248H330.5V260H225.5V248Z" fill="white" />
          <path
            d="M330.5 259H225.5V261H330.5V259Z"
            fill="#F2F3F7"
            mask="url(#path-10-inside-1_1462_13889)"
          />
          <rect
            width="210"
            height="19.5"
            transform="translate(120.5 260)"
            fill="white"
          />
          <rect
            x="124.5"
            y="264"
            width="171.25"
            height="11.5"
            rx="5.75"
            fill="#F2F3F7"
          />
          <rect
            x="303.75"
            y="264.5"
            width="22.75"
            height="10.5"
            rx="5.25"
            fill="#424DE5"
          />
        </g>
        <g filter="url(#filter4_d_1462_13889)">
          <rect
            width="104"
            height="22"
            transform="translate(16.5)"
            fill="white"
          />
          <rect
            x="28.5"
            y="7.875"
            width="43.25"
            height="6.25"
            rx="2"
            fill="#F2F3F7"
          />
          <rect
            width="52"
            height="12"
            transform="translate(16.5 22)"
            fill="white"
          />
          <rect x="16.5" y="32" width="52" height="2" fill="#475AFF" />
          <mask id="path-16-inside-2_1462_13889" fill="white">
            <path d="M68.5 22H120.5V34H68.5V22Z" />
          </mask>
          <path d="M68.5 22H120.5V34H68.5V22Z" fill="white" />
          <path
            d="M120.5 33H68.5V35H120.5V33Z"
            fill="#F2F3F7"
            mask="url(#path-16-inside-2_1462_13889)"
          />
          <rect
            width="104"
            height="18.5"
            transform="translate(16.5 34)"
            fill="white"
          />
          <g
            clipPath="url(#clip1_1462_13889)"
            filter="url(#filter5_i_1462_13889)"
          >
            <rect
              width="104"
              height="208"
              transform="translate(16.5 52.5)"
              fill="#F9F9FB"
            />
            <g filter="url(#filter6_d_1462_13889)">
              <rect
                x="24.5"
                y="60.5"
                width="88"
                height="31"
                rx="6"
                fill="white"
              />
            </g>
            <g filter="url(#filter7_d_1462_13889)">
              <rect
                x="24.5"
                y="99.5"
                width="88"
                height="31"
                rx="6"
                fill="white"
              />
            </g>
            <g filter="url(#filter8_d_1462_13889)">
              <rect
                x="24.5"
                y="138.5"
                width="88"
                height="31"
                rx="6"
                fill="white"
              />
            </g>
            <g filter="url(#filter9_d_1462_13889)">
              <rect
                x="24.5"
                y="177.5"
                width="88"
                height="31"
                rx="6"
                fill="white"
              />
            </g>
            <g filter="url(#filter10_d_1462_13889)">
              <rect
                x="24.5"
                y="216.5"
                width="88"
                height="31"
                rx="6"
                fill="white"
              />
            </g>
            <g filter="url(#filter11_d_1462_13889)">
              <rect
                x="24.5"
                y="255.5"
                width="88"
                height="31"
                rx="6"
                fill="white"
              />
            </g>
          </g>
          <rect
            width="104"
            height="19"
            transform="translate(16.5 260.5)"
            fill="white"
          />
        </g>
        <g filter="url(#filter12_d_1462_13889)">
          <rect width="16.5" height="279.5" fill="white" />
          <rect x="6.25" y="12" width="4" height="12" rx="2" fill="#F2F3F7" />
          <rect x="5.25" y="52" width="6" height="6" rx="2" fill="#F2F3F7" />
          <rect x="5.25" y="66" width="6" height="6" rx="2" fill="#F2F3F7" />
          <rect x="5.25" y="80" width="6" height="6" rx="2" fill="#F2F3F7" />
          <rect x="5.25" y="94" width="6" height="6" rx="2" fill="#F2F3F7" />
          <rect x="5.25" y="108" width="6" height="6" rx="2" fill="#F2F3F7" />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_1462_13889"
          x="327.5"
          y="-3"
          width="114"
          height="287.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.121097 0 0 0 0 0.136234 0 0 0 0 0.197579 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1462_13889"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1462_13889"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_i_1462_13889"
          x="330.5"
          y="75.25"
          width="106"
          height="204.25"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.384314 0 0 0 0 0.427451 0 0 0 0 0.6 0 0 0 0.24 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1462_13889"
          />
        </filter>
        <filter
          id="filter2_d_1462_13889"
          x="116.5"
          y="-4"
          width="218"
          height="30"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0 0.196078 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1462_13889"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1462_13889"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_1462_13889"
          x="116.5"
          y="243"
          width="218"
          height="39.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0 0.196078 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1462_13889"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1462_13889"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_1462_13889"
          x="11.5"
          y="-3"
          width="112"
          height="287.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.121097 0 0 0 0 0.136234 0 0 0 0 0.197579 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1462_13889"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1462_13889"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_i_1462_13889"
          x="16.5"
          y="52.5"
          width="104"
          height="208"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.384314 0 0 0 0 0.427451 0 0 0 0 0.6 0 0 0 0.24 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1462_13889"
          />
        </filter>
        <filter
          id="filter6_d_1462_13889"
          x="22.5"
          y="59.5"
          width="92"
          height="35"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0 0.196078 0 0 0 0.13 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1462_13889"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1462_13889"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_d_1462_13889"
          x="22.5"
          y="98.5"
          width="92"
          height="35"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0 0.196078 0 0 0 0.13 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1462_13889"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1462_13889"
            result="shape"
          />
        </filter>
        <filter
          id="filter8_d_1462_13889"
          x="22.5"
          y="137.5"
          width="92"
          height="35"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0 0.196078 0 0 0 0.13 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1462_13889"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1462_13889"
            result="shape"
          />
        </filter>
        <filter
          id="filter9_d_1462_13889"
          x="22.5"
          y="176.5"
          width="92"
          height="35"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0 0.196078 0 0 0 0.13 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1462_13889"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1462_13889"
            result="shape"
          />
        </filter>
        <filter
          id="filter10_d_1462_13889"
          x="22.5"
          y="215.5"
          width="92"
          height="35"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0 0.196078 0 0 0 0.13 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1462_13889"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1462_13889"
            result="shape"
          />
        </filter>
        <filter
          id="filter11_d_1462_13889"
          x="22.5"
          y="254.5"
          width="92"
          height="35"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0 0.196078 0 0 0 0.13 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1462_13889"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1462_13889"
            result="shape"
          />
        </filter>
        <filter
          id="filter12_d_1462_13889"
          x="-4"
          y="-3"
          width="24.5"
          height="287.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.121097 0 0 0 0 0.136234 0 0 0 0 0.197579 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1462_13889"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1462_13889"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_1462_13889">
          <rect width="436.5" height="279.5" rx="12" fill="white" />
        </clipPath>
        <clipPath id="clip1_1462_13889">
          <rect
            width="104"
            height="208"
            fill="white"
            transform="translate(16.5 52.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
